import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ductDbName',
  standalone: false,
})
export class DuctDbNamePipe implements PipeTransform {
  transform(name: string | undefined | null): string | undefined {
    if (!name) return name ?? undefined;
    if (!name.includes('x')) return name;
    const [before, after] = name.split('x');
    return `DB${before} ${after}`;
  }
}
